"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initUsStateLogic = void 0;
var enableSubmitButton = function enableSubmitButton() {
  var submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.disabled = false;
  }
};
var disableSubmitButton = function disableSubmitButton() {
  var submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.disabled = true;
  }
};
var hideUSStateField = function hideUSStateField() {
  var inputUSStateLi = document.querySelector('.inputUSState_li');
  if (inputUSStateLi) {
    inputUSStateLi.style.display = 'none';
  }
};
var showUSStateField = function showUSStateField() {
  var inputUSStateLi = document.querySelector('.inputUSState_li');
  if (inputUSStateLi) {
    inputUSStateLi.style.display = 'list-item';
  }
};
var showStateRequiredMessage = function showStateRequiredMessage() {
  var _a;
  var errorDiv = (_a = document.querySelector('.inputUSState_li')) === null || _a === void 0 ? void 0 : _a.querySelector('.error');
  if (errorDiv) {
    errorDiv.textContent = 'This information is required.';
  }
};
var clearStateRequiredMessage = function clearStateRequiredMessage() {
  var _a;
  var errorDiv = (_a = document.querySelector('.inputUSState_li')) === null || _a === void 0 ? void 0 : _a.querySelector('.error');
  if (errorDiv) {
    errorDiv.textContent = '';
  }
};
var countryChangeListener = function countryChangeListener(ev) {
  var combinedLocation = ev.target;
  var inputUSState = document.getElementById('inputUSState');
  if (combinedLocation && inputUSState) {
    inputUSState.value = 'XXX';
    if (combinedLocation.value === '|NUSSAXXX|US|XXX|') {
      showUSStateField();
      disablePlaceholderState();
    } else {
      hideUSStateField();
    }
  }
  toggleControls();
};
var attachCountryChangeListener = function attachCountryChangeListener() {
  var combinedLocation = document.getElementById('combinedLocation');
  combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.addEventListener('change', countryChangeListener);
};
var removeCountryChangeListener = function removeCountryChangeListener() {
  var combinedLocation = document.getElementById('combinedLocation');
  combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.removeEventListener('change', countryChangeListener);
};
var attachUSStateChangeListener = function attachUSStateChangeListener() {
  var inputUSState = document.getElementById('inputUSState');
  inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.addEventListener('change', toggleControls);
};
var removeUSStateChangeListener = function removeUSStateChangeListener() {
  var inputUSState = document.getElementById('inputUSState');
  inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.removeEventListener('change', toggleControls);
};
var toggleControls = function toggleControls() {
  var combinedLocation = document.getElementById('combinedLocation');
  var inputUSState = document.getElementById('inputUSState');
  if ((combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.value) === '|NUSSAXXX|US|XXX|') {
    if ((inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.value) != 'XXX') {
      enableSubmitButton();
      clearStateRequiredMessage();
    } else {
      showStateRequiredMessage();
      disableSubmitButton();
    }
  } else {
    enableSubmitButton();
  }
};
var disablePlaceholderState = function disablePlaceholderState() {
  var inputUSState = document.getElementById('inputUSState');
  if (inputUSState) {
    var placeholderOption = inputUSState.querySelector('option[value="XXX"]');
    var emptyOptionValue = inputUSState.querySelector('option[value=""]');
    if (placeholderOption) {
      placeholderOption.disabled = true;
      placeholderOption.style.display = 'none';
    }
    if (emptyOptionValue) {
      inputUSState.removeChild(emptyOptionValue);
    }
  }
};
var initUsStateLogic = function initUsStateLogic() {
  hideUSStateField();
  removeCountryChangeListener();
  attachCountryChangeListener();
  removeUSStateChangeListener();
  attachUSStateChangeListener();
  toggleControls();
};
exports.initUsStateLogic = initUsStateLogic;
//# sourceMappingURL=usStates.js.map